var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "36", height: "36", viewBox: "0 0 36 36", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("rect", { x: "6.406", y: "3.375", width: "37.078", height: "4.287", rx: "1.85", transform: "rotate(45 6.406 3.375)", fill: "#9C9C9C" }),
    React.createElement("rect", { x: "3.375", y: "29.593", width: "37.078", height: "4.287", rx: "1.85", transform: "rotate(-45 3.375 29.593)", fill: "#9C9C9C" })
  );
});